@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_cus_mobile.we

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.withTimeoutOrNull
import org.example.project.engineslot.SLOT_BEREICH_WE
import org.example.project.dashboard.DashboardTheme
import org.example.project.screens_cus_mobile.loadMobileErlaubteStandorte
import org.example.project.screens_cus_mobile.MobileYardPalettenscheinExportHost
import org.example.project.screens_cus_mobile.MOBILE_YARD_STORED_PDF_ENABLED
import org.example.project.screens_cus_mobile.mobileClaimForCurrentUser
import org.example.project.screens_cus_mobile.mobileCurrentBearbeiterId
import org.example.project.screens_cus_mobile.mobileIsOwnRunning
import org.example.project.screens_cus_mobile.mobileIsOwnBearbeitung
import org.example.project.screens_cus_mobile.mobileIsSelectableAngekommen
import org.example.project.screens_cus_mobile.mobileIsUnassignedRunning
import org.example.project.screens_cus_mobile.mobileStandortErlaubt
import org.example.project.service.InfrastrukturApi
import org.example.project.service.GlobalManager
import org.example.project.service.YardApi
import org.example.project.service.YardEngineApi
import org.example.project.service.YardFlowApi
import org.example.project.service.YardLiveSync
import org.example.project.service.ZustandManager
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.utils.All
import org.example.project.yard.suggestWeTorOnArrival
import org.example.project.yard.yardPinBestaetigt
import org.example.project.yard.yardPinCode
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import kotlin.js.Date

@Composable
fun CUSMobileWEFlowScreen() {
    val scope = rememberCoroutineScope()
    var liste by remember { mutableStateOf<List<All>>(emptyList()) }
    var weLkwAll by remember { mutableStateOf<List<All>>(emptyList()) }
    var kontrolleDefinitionen by remember { mutableStateOf<List<All>>(emptyList()) }
    var aktiverFlow by remember { mutableStateOf<All?>(null) }
    var wartenderAuftrag by remember { mutableStateOf<All?>(null) }
    var pinPruefungAuftrag by remember { mutableStateOf<All?>(null) }
    var kontrolleHeaderAuftrag by remember { mutableStateOf<All?>(null) }
    var startenderAuftragId by remember { mutableStateOf<String?>(null) }
    var palettenscheinQueue by remember { mutableStateOf<List<All>>(emptyList()) }
    var letzterAbschlussAuftrag by remember { mutableStateOf<All?>(null) }
    var palettenscheinWarteAuftrag by remember { mutableStateOf<All?>(null) }
    var palettenscheinErstellungAktiv by remember { mutableStateOf(false) }
    var palettenscheinGesamt by remember { mutableStateOf(0) }
    var palettenscheinWarteFertig by remember { mutableStateOf(false) }
    var palettenscheinWarteFehler by remember { mutableStateOf(false) }
    var palettenscheinWarteText by remember { mutableStateOf("Palettenschein wird erstellt") }
    var palettenscheinDokumentProgress by remember { mutableStateOf(0) }
    val bearbeiterId = mobileCurrentBearbeiterId()
    val refreshVersion = YardLiveSync.version()

    fun zeigeWeBearbeitung(auftrag: All) {
        when {
            auftrag.zustand == ZustandManager.TOR_ZUGEWIESEN -> {
                kontrolleHeaderAuftrag = null
                wartenderAuftrag = auftrag
                pinPruefungAuftrag = null
                aktiverFlow = null
            }
            auftrag.zustand == ZustandManager.PIN_ABFRAGE && !yardPinBestaetigt(auftrag) -> {
                kontrolleHeaderAuftrag = null
                pinPruefungAuftrag = auftrag
                wartenderAuftrag = null
                aktiverFlow = null
            }
            auftrag.zustand == ZustandManager.IN_VERLADUNG -> {
                kontrolleHeaderAuftrag = auftrag
                aktiverFlow = auftrag
                wartenderAuftrag = null
                pinPruefungAuftrag = null
            }
        }
    }

    suspend fun weBearbeitungWiederAufnehmen(auftrag: All): All {
        val claimed = mobileClaimForCurrentUser(auftrag)
        return when (auftrag.zustand) {
            ZustandManager.TOR_ZUGEWIESEN -> YardFlowApi.maNimmtAuftragAn(
                auftrag = claimed,
                artCode = SLOT_BEREICH_WE,
                firmenId = claimed.firmenId
            )
            ZustandManager.PIN_ABFRAGE -> YardFlowApi.fahrerBestaetigtAngesetzt(
                auftrag = claimed,
                artCode = SLOT_BEREICH_WE,
                firmenId = claimed.firmenId
            )
            ZustandManager.IN_VERLADUNG -> YardFlowApi.maBestaetigtPin(
                auftrag = claimed,
                artCode = SLOT_BEREICH_WE,
                firmenId = claimed.firmenId
            )
            else -> claimed
        }
    }

    suspend fun ladeDaten() {
        val erlaubteStandorte = loadMobileErlaubteStandorte()
        kontrolleDefinitionen = YardApi.loadKontrolleDefinitionen().filter { it.aktivWe }
        val alle = YardApi.loadWeLkwListe()
            .filter { it.zustand != ZustandManager.ABGESCHLOSSEN && it.zustand != ZustandManager.STORNIERT }
            .filter { mobileStandortErlaubt(it, erlaubteStandorte) }
        weLkwAll = alle
        liste = alle
            .filter { mobileIsSelectableAngekommen(it, bearbeiterId) }
            .sortedWith(
                compareBy<All> { if (mobileIsOwnBearbeitung(it, bearbeiterId)) 0 else 1 }
                    .thenBy { if (it.ablaufPrio > 0) it.ablaufPrio else Int.MAX_VALUE }
                    .thenBy { it.uhrzeitAnmeldung }
            )
            .mobileWeSammelReps()
        if (palettenscheinWarteAuftrag != null || palettenscheinErstellungAktiv || palettenscheinQueue.isNotEmpty()) return
        if (wartenderAuftrag != null || pinPruefungAuftrag != null || aktiverFlow != null) return
        alle.firstOrNull { mobileIsOwnRunning(it, bearbeiterId) }?.let { eigener ->
            zeigeWeBearbeitung(eigener)
            return
        }
        alle.firstOrNull { mobileIsUnassignedRunning(it) }?.let { unzugeordnet ->
            val wiederaufgenommen = weBearbeitungWiederAufnehmen(unzugeordnet)
            zeigeWeBearbeitung(wiederaufgenommen)
        }
    }

    LaunchedEffect(refreshVersion) {
        ladeDaten()
    }

    LaunchedEffect(wartenderAuftrag?.id, wartenderAuftrag?.lfdNr) {
        val wartend = wartenderAuftrag ?: return@LaunchedEffect
        while (wartenderAuftrag != null) {
            val aktuell = YardApi.loadWeLkwListe(wartend.firmenId)
                .firstOrNull { it.id == wartend.id || (it.lfdNr > 0 && it.lfdNr == wartend.lfdNr) }
            if (aktuell != null) {
                wartenderAuftrag = aktuell
                if (aktuell.zustand == ZustandManager.PIN_ABFRAGE) {
                    pinPruefungAuftrag = aktuell
                    wartenderAuftrag = null
                    return@LaunchedEffect
                }
                if (aktuell.zustand == ZustandManager.IN_VERLADUNG) {
                    aktiverFlow = aktuell
                    wartenderAuftrag = null
                    return@LaunchedEffect
                }
                if (aktuell.zustand != ZustandManager.TOR_ZUGEWIESEN) {
                    wartenderAuftrag = null
                    ladeDaten()
                    return@LaunchedEffect
                }
            }
            delay(2000)
        }
    }

    suspend fun weAbladenStarten(auftrag: All): All {
        val auftragMitTor = if (auftrag.tor == null) {
            suggestWeTorOnArrival(auftrag, auftrag.firmenId).auftrag
        } else {
            auftrag
        }
        val tor = auftragMitTor.tor?.let { torNummer ->
            InfrastrukturApi.loadTore(auftragMitTor.firmenId)
                .firstOrNull {
                    it.tor == torNummer &&
                        it.gesperrt != true &&
                        (it.standort == auftragMitTor.standort || auftragMitTor.standort.isBlank())
                }
        }
        val aktualisiert = YardFlowApi.maNimmtAuftragAn(
            auftrag = auftragMitTor,
            artCode = SLOT_BEREICH_WE,
            firmenId = auftragMitTor.firmenId,
            tor = tor
        )
        return aktualisiert
    }

    fun starteWeAbladen(auftrag: All) {
        if (startenderAuftragId != null) return
        startenderAuftragId = auftrag.id.ifBlank { auftrag.lfdNr.toString() }
        liste = liste.filterNot { it.id == auftrag.id || (it.lfdNr > 0 && it.lfdNr == auftrag.lfdNr) }
        scope.launch {
            try {
                val claimed = mobileClaimForCurrentUser(auftrag)
                val aktualisiert = withTimeoutOrNull(10000L) {
                    weAbladenStarten(claimed)
                }
                if (aktualisiert != null) {
                    when {
                        aktualisiert.zustand == ZustandManager.PIN_ABFRAGE && !yardPinBestaetigt(aktualisiert) -> {
                            pinPruefungAuftrag = aktualisiert
                        }
                        aktualisiert.zustand == ZustandManager.IN_VERLADUNG -> {
                            kontrolleHeaderAuftrag = aktualisiert
                            aktiverFlow = aktualisiert
                        }
                        aktualisiert.zustand == ZustandManager.TOR_ZUGEWIESEN -> {
                            wartenderAuftrag = aktualisiert
                        }
                        else -> {
                            ladeDaten()
                        }
                    }
                } else {
                    ladeDaten()
                }
            } finally {
                startenderAuftragId = null
            }
        }
    }

    suspend fun pinBestaetigen(auftrag: All): All {
        val aktualisiert = YardFlowApi.maBestaetigtPin(auftrag, SLOT_BEREICH_WE, auftrag.firmenId)
        ladeDaten()
        return aktualisiert
    }

    suspend fun flowAbschliessen(auftrag: All, leergut: String, antworten: Map<String, String>, istPaletten: String): Boolean {
        val palettenGetauscht = antworten["mobil.palettenGetauscht"].orEmpty().equals("true", true)
        val pending = auftrag.copy(
            leerpalettenanzahl = leergut.toIntOrNull() ?: 0,
            palettenWerte = auftrag.palettenWerte + antworten.filterValues { it.isNotBlank() },
            mobilPalettenAbgeladenBestaetigt = true,
            mobilPalettenGetauscht = palettenGetauscht,
            mobilPalettenAusgang = leergut.ifBlank { "0" },
            mobilIstPaletten = istPaletten.toIntOrNull() ?: 0,
            mobilWePalettenUnbeschaedigt = antworten["mobil.wePalettenUnbesch\u00E4digt"].orEmpty().toIntOrNull() ?: 0,
            mobilWePalettenFehlmenge = antworten["mobil.wePalettenFehlmenge"].orEmpty().toIntOrNull() ?: 0,
            mobilWePalettenBruch = antworten["mobil.wePalettenBruch"].orEmpty().toIntOrNull() ?: 0,
            mobilWePalettenUeberzaehlig = antworten["mobil.wePaletten\u00DCberz\u00E4hlig"].orEmpty().toIntOrNull() ?: 0,
            yardabschlussIstPaletten = istPaletten.toIntOrNull() ?: 0,
            dokumenteFertig = false
        )
        letzterAbschlussAuftrag = pending
        palettenscheinQueue = palettenscheinQueue + pending
        return true
    }

    suspend fun palettenscheinWeAbschlussSpeichern(auftrag: All): All? {
        val istPaletten = auftrag.mobilIstPaletten.toString()
        val ist = istPaletten.toIntOrNull() ?: 0
        val soll = auftrag.palettenanzahl.coerceAtLeast(0)
        val werte = auftrag.palettenWerte
        GlobalManager.markLocalScreenWrite("MobileWEAuswahlScreen", suppressMs = 60000L)
        val gespeichert = if (soll > 0 && ist < soll) {
            YardEngineApi.weTeilabschluss(
                auftrag = auftrag,
                firmenId = auftrag.firmenId,
                istPaletten = istPaletten
            )
        } else {
            YardEngineApi.weAbschluss(
                auftrag = auftrag,
                firmenId = auftrag.firmenId,
                istPaletten = istPaletten
            )
        }
        if (gespeichert != null) {
            YardLiveSync.markAuftragChanged(gespeichert)
        }
        return gespeichert
    }

    MobileYardPalettenscheinExportHost(
        art = "WE",
        auftrag = if (palettenscheinErstellungAktiv) palettenscheinQueue.firstOrNull() else null,
        onPhaseChange = { palettenscheinWarteText = it },
        onDocumentProgress = { palettenscheinDokumentProgress = it.coerceIn(0, 100) },
        onPalettenscheinUploaded = { current ->
            palettenscheinWeAbschlussSpeichern(current)
        },
        onFinished = { success ->
            if (!success) {
                palettenscheinWarteFehler = true
            } else {
                scope.launch {
                    palettenscheinErstellungAktiv = false
                    val remaining = palettenscheinQueue.drop(1)
                    palettenscheinQueue = remaining
                    if (remaining.isEmpty()) {
                        palettenscheinDokumentProgress = 100
                        palettenscheinWarteFertig = true
                        palettenscheinWarteText = "Dokumente wurden erzeugt."
                        delay(900)
                        palettenscheinWarteAuftrag = null
                        palettenscheinErstellungAktiv = false
                        palettenscheinGesamt = 0
                        palettenscheinWarteFertig = false
                        palettenscheinWarteFehler = false
                            palettenscheinWarteText = "Palettenschein wird erstellt"
                            palettenscheinDokumentProgress = 0
                            kontrolleHeaderAuftrag = null
                            aktiverFlow = null
                            ladeDaten()
                    } else {
                        palettenscheinDokumentProgress = 0
                        palettenscheinErstellungAktiv = true
                        palettenscheinWarteText = "Palettenschein wird erstellt"
                    }
                }
            }
        }
    )

    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(16.px)
            padding(12.px)
            height(100.percent)
            minHeight(0.px)
            boxSizing("border-box")
        }
    }) {
        if (palettenscheinWarteAuftrag != null) {
            MobileWeArbeitsbereich(auftrag = palettenscheinWarteAuftrag!!) {
                MobileWePalettenscheinWarteScreen(
                    fertig = palettenscheinWarteFertig,
                    fehler = palettenscheinWarteFehler,
                    gesamt = palettenscheinGesamt,
                    verbleibend = palettenscheinQueue.size,
                    dokumentProgress = palettenscheinDokumentProgress,
                    statusText = palettenscheinWarteText,
                    onOk = {
                        if (!palettenscheinWarteFertig) return@MobileWePalettenscheinWarteScreen
                        palettenscheinWarteAuftrag = null
                        palettenscheinErstellungAktiv = false
                        palettenscheinGesamt = 0
                        palettenscheinWarteFertig = false
                        palettenscheinWarteFehler = false
                        palettenscheinWarteText = "Palettenschein wird erstellt"
                        palettenscheinDokumentProgress = 0
                        scope.launch { ladeDaten() }
                    }
                )
            }
        } else if (wartenderAuftrag != null) {
            MobileWeArbeitsbereich(auftrag = wartenderAuftrag!!) {
                MobileWeWarteScreen()
            }
        } else if (pinPruefungAuftrag != null) {
            MobileWeArbeitsbereich(auftrag = pinPruefungAuftrag!!) {
                MobileWePinBestaetigungScreen(
                    auftrag = pinPruefungAuftrag!!,
                    onZurueck = { pinPruefungAuftrag = null },
                    onPinBestaetigt = { auftrag ->
                        scope.launch {
                            aktiverFlow = pinBestaetigen(auftrag)
                            pinPruefungAuftrag = null
                        }
                    }
                )
            }
        } else if (aktiverFlow != null) {
            val aktiveWeGruppe = weLkwAll.mobileWeSammelGroup(aktiverFlow!!)
                .filter { it.zustand != ZustandManager.ABGESCHLOSSEN && it.zustand != ZustandManager.STORNIERT }
                .ifEmpty { listOf(aktiverFlow!!) }
            MobileWeArbeitsbereich(auftrag = kontrolleHeaderAuftrag ?: aktiverFlow!!) {
                CUSMobileWEKontrolleScreen(
                    auftrag = aktiverFlow!!,
                    abschlussAuftraege = aktiveWeGruppe,
                    kontrolleDefinitionen = kontrolleDefinitionen,
                    onZurueck = {
                        kontrolleHeaderAuftrag = null
                        aktiverFlow = null
                    },
                    onAbschliessen = { abschlussAuftrag, leergut, antworten, istPaletten ->
                        flowAbschliessen(abschlussAuftrag, leergut, antworten, istPaletten)
                    },
                    onAktuellerAuftragChange = { aktuellerAuftrag ->
                        kontrolleHeaderAuftrag = aktuellerAuftrag
                    },
                    onFertig = {
                        val exportQueue = palettenscheinQueue.ifEmpty {
                            letzterAbschlussAuftrag?.let { listOf(it) }.orEmpty()
                        }
                        if (palettenscheinQueue.isEmpty() && exportQueue.isNotEmpty()) {
                            palettenscheinQueue = exportQueue
                        }
                        val warteAuftrag = exportQueue.firstOrNull() ?: aktiverFlow
                        if (warteAuftrag != null) {
                            GlobalManager.markLocalScreenWrite("MobileWEAuswahlScreen", suppressMs = 60000L)
                            palettenscheinWarteAuftrag = warteAuftrag
                            kontrolleHeaderAuftrag = warteAuftrag
                            palettenscheinGesamt = exportQueue.size.coerceAtLeast(1)
                            palettenscheinErstellungAktiv = true
                            palettenscheinWarteFertig = false
                            palettenscheinWarteFehler = false
                            palettenscheinWarteText = "Palettenschein wird erstellt"
                            palettenscheinDokumentProgress = 0
                            if (!MOBILE_YARD_STORED_PDF_ENABLED) {
                                palettenscheinWarteAuftrag = null
                                kontrolleHeaderAuftrag = null
                                aktiverFlow = null
                            }
                        }
                    }
                )
            }
        } else {
            MobileWeHeader(
                offen = liste.size,
                inBearbeitung = liste.count { it.zustand >= ZustandManager.TOR_ZUGEWIESEN }
            )
            Div({ style { width(100.percent) } }) {
                LumaticaButton(
                    label = if (startenderAuftragId != null) "Wird gestartet..." else "Lkw Abladen",
                    onClick = {
                        if (startenderAuftragId != null) return@LumaticaButton
                        val erster = liste.firstOrNull() ?: return@LumaticaButton
                        starteWeAbladen(erster)
                    },
                    variant = LumaticaButtonVariant.Action,
                    enabled = liste.isNotEmpty() && startenderAuftragId == null,
                    heightPx = 42
                )
            }

            liste.forEach { auftrag ->
                val sammelGroup = weLkwAll.mobileWeSammelGroup(auftrag)
                val eigeneZuweisung = mobileIsOwnBearbeitung(auftrag, bearbeiterId)
                Div({
                    style {
                        padding(16.px)
                        borderRadius(22.px)
                        background("linear-gradient(180deg, rgba(18,22,32,0.92) 0%, rgba(11,14,22,0.86) 100%)")
                        property("border", if (eigeneZuweisung) "2px solid #ff3b30" else "1px solid rgba(255,255,255,0.13)")
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(10.px)
                        property("box-shadow", "0 16px 30px rgba(0,0,0,0.24)")
                        cursor(if (eigeneZuweisung) "pointer" else "default")
                    }
                    if (eigeneZuweisung) onClick { starteWeAbladen(auftrag) }
                }) {
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            alignItems(AlignItems.Center)
                            gap(8.px)
                            flexWrap(FlexWrap.Wrap)
                        }
                    }) {
                        Span({ style { color(rgba(255, 255, 255, 0.82)); fontSize(13.px); fontWeight("600") } }) {
                            Text("Wareneingang")
                        }
                        Span({ style { color(rgba(255, 255, 255, 0.78)); fontSize(12.px); textAlign("right") } }) {
                            Text("Prio ${if (auftrag.ablaufPrio > 0) auftrag.ablaufPrio else "-"}")
                        }
                    }

                    MobileWeInfoRow("Fahrer", mobileWeFahrerLabel(auftrag))
                    MobileWeInfoRow("Lieferscheinnummer", sammelGroup.mobileWeCompactLieferscheinnummer(auftrag))
                    MobileWeInfoRow("Paletten", sammelGroup.mobileWeTotalPalettenLabel(auftrag))
                    MobileWeInfoRow("PIN", yardPinCode(auftrag))
                    MobileWeInfoRow("LKW", auftrag.lkwkennzeichen.ifBlank { "-" })
                    MobileWeInfoRow("Auflieger", auftrag.aufliegerkennzeichen.ifBlank { "-" })
                    MobileWeInfoRow("Tor", auftrag.tor?.toString() ?: "offen")
                        MobileWeInfoRow("Status", mobileWeStatusText(auftrag.zustand))
                }
            }
        }
    }
}

private fun mobileWeStatusText(zustand: Int): String =
    "$zustand - " + when (zustand) {
        ZustandManager.IN_VERLADUNG -> "Beim Abladen"
        else -> ZustandManager.textFor(zustand)
    }

@Composable
private fun MobileWePalettenscheinWarteScreen(
    fertig: Boolean,
    fehler: Boolean,
    gesamt: Int,
    verbleibend: Int,
    dokumentProgress: Int,
    statusText: String,
    onOk: () -> Unit
) {
    val total = gesamt.coerceAtLeast(1)
    val done = (total - verbleibend).coerceIn(0, total)
    val current = if (fertig) total else (done + 1).coerceIn(1, total)
    val currentProgress = dokumentProgress.coerceIn(0, 100)
    val progress = if (fertig) 100 else (((done * 100) + currentProgress) / total).coerceIn(0, 100)
    Div({
        style {
            flex(1)
            minHeight(220.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div({
            style {
                width(100.percent)
                maxWidth(420.px)
                padding(18.px)
                borderRadius(8.px)
                backgroundColor(rgba(255, 255, 255, 0.06))
                property("border", "1px solid rgba(255,255,255,0.14)")
                textAlign("center")
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(16.px)
                fontWeight("800")
                lineHeight("1.35")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(14.px)
                alignItems(AlignItems.Center)
            }
        }) {
            Text(
                when {
                    fertig -> statusText.ifBlank { "Dokumente wurden erzeugt." }
                    fehler -> "Dokumente konnten nicht erzeugt werden. Bitte am Leitstand prüfen."
                    else -> "${statusText.ifBlank { "Dokumente werden erstellt" }} $current/$total"
                }
            )
            Div({
                style {
                    width(100.percent)
                    height(10.px)
                    borderRadius(999.px)
                    backgroundColor(rgba(255, 255, 255, 0.08))
                    property("overflow", "hidden")
                    property("border", "1px solid rgba(255,255,255,0.10)")
                }
            }) {
                Div({
                    style {
                        width(progress.percent)
                        height(100.percent)
                        backgroundColor(DashboardTheme.ACCENT)
                        property("transition", "width 220ms ease")
                    }
                })
            }
            Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(13.px); fontWeight("700") } }) {
                Text("$done/$total fertig")
            }
            LumaticaButton(
                label = "OK",
                onClick = onOk,
                variant = LumaticaButtonVariant.Action,
                enabled = fertig,
                heightPx = 42
            )
        }
    }
}

private fun mobileWeFahrerLabel(auftrag: All): String =
    auftrag.fahrername.ifBlank {
        auftrag.name.ifBlank {
            auftrag.lkwkennzeichen.ifBlank { "Unbekannter Fahrer" }
        }
    }

@Composable
private fun MobileWeArbeitsbereich(
    auftrag: All,
    content: @Composable () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(16.px)
            minHeight(100.percent)
            height(100.percent)
            width(100.percent)
            flex(1)
        }
    }) {
        MobileWeProcessHeader(auftrag)
        content()
    }
}

@Composable
private fun MobileWePinBestaetigungScreen(
    auftrag: All,
    @Suppress("UNUSED_PARAMETER")
    onZurueck: () -> Unit,
    onPinBestaetigt: (All) -> Unit
) {
    var pinEingabe by remember(auftrag.id, auftrag.lfdNr) { mutableStateOf("") }
    var fehler by remember(auftrag.id, auftrag.lfdNr) { mutableStateOf("") }
    val erwartetePin = yardPinCode(auftrag)

    Div({
        style {
            flex(1)
            minHeight(0.px)
            height(100.percent)
            width(100.percent)
            position(Position.Relative)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
        }
    }) {
        Div({
            style {
                position(Position.Absolute)
                top(50.percent)
                left(50.percent)
                property("transform", "translate(-50%, -50%)")
                width(100.percent)
                maxWidth(360.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(10.px)
                boxSizing("border-box")
            }
        }) {
            Input(InputType.Text) {
                value(pinEingabe)
                onInput {
                    pinEingabe = it.value.trim()
                    fehler = ""
                }
                attr("placeholder", "PIN eingeben")
                style {
                    height(58.px)
                    width(100.percent)
                    padding(0.px, 14.px)
                    borderRadius(8.px)
                    border(2.px, LineStyle.Solid, rgba(255, 255, 255, 0.34))
                    backgroundColor(rgba(0, 0, 0, 0.14))
                    color(Color.white)
                    fontSize(24.px)
                    fontWeight("900")
                    textAlign("center")
                    boxSizing("border-box")
                }
            }
            if (fehler.isNotBlank()) {
                Span({ style { color(Color("#ff6b6b")); fontSize(13.px); fontWeight("700"); textAlign("center") } }) {
                    Text(fehler)
                }
            }
        }
        Div({
            style {
                position(Position.Absolute)
                left(50.percent)
                bottom(0.px)
                property("transform", "translateX(-50%)")
                width(100.percent)
                maxWidth(360.px)
                boxSizing("border-box")
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
            }
        }) {
            LumaticaButton(
                label = "PIN bestätigen",
                onClick = {
                    if (pinEingabe == erwartetePin) {
                        onPinBestaetigt(auftrag)
                    } else {
                        fehler = "PIN stimmt nicht."
                    }
                },
                variant = LumaticaButtonVariant.Action,
                heightPx = 42
            )
        }
    }
}

@Composable
private fun MobileWeWarteScreen() {
    Div({
        style {
            flex(1)
            minHeight(220.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Div({
            style {
                width(100.percent)
                maxWidth(420.px)
                padding(18.px)
                borderRadius(8.px)
                backgroundColor(rgba(255, 255, 255, 0.06))
                property("border", "1px solid rgba(255,255,255,0.14)")
                textAlign("center")
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(16.px)
                fontWeight("800")
                lineHeight("1.35")
            }
        }) {
            Text("Bitte warte bis der Fahrer das Ansetzen bestätigt hat.")
        }
    }
}

@Composable
private fun MobileWeProcessHeader(auftrag: All) {
    H3({
        style {
            margin(0.px)
            color(DashboardTheme.TEXT_LIGHT)
            fontSize(20.px)
            fontWeight("800")
            textAlign("center")
        }
    }) {
        Text("Wareneingang")
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)
            gap(12.px)
            flexWrap(FlexWrap.Wrap)
        }
    }) {
        MobileWeProcessMetric(
            icon = "images/order.svg",
            value = auftrag.lieferscheinnummer.ifBlank { "-" }
        )
        MobileWeProcessMetric(
            icon = "images/toruebersicht.svg",
            value = auftrag.tor?.toString() ?: "-"
        )
        MobileWeProcessMetric(
            icon = "images/paletten.svg",
            value = auftrag.palettenanzahl.takeIf { it > 0 }?.toString() ?: "-"
        )
    }
}

@Composable
private fun MobileWeProcessMetric(icon: String, value: String) {
    Div({
        style {
            flex(1)
            minWidth(86.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            gap(8.px)
            minHeight(34.px)
        }
    }) {
        Img(src = icon) {
            style {
                width(24.px)
                height(24.px)
                property("filter", "brightness(0) invert(1)")
                flexShrink(0)
            }
        }
        Span({
            style {
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(17.px)
                fontWeight("900")
                lineHeight("1")
                overflow("hidden")
                property("text-overflow", "ellipsis")
                property("white-space", "nowrap")
            }
        }) {
            Text(value)
        }
    }
}

private fun aktuelleMobileWeUhrzeit(): String {
    val date = Date()
    return "${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}"
}

@Composable
private fun MobileWeHeader(offen: Int, inBearbeitung: Int) {
    Div({
        style {
            padding(18.px)
            borderRadius(8.px)
            background("linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%), ${DashboardTheme.PREMIUM_SURFACE_BG}")
            property("border", "1px solid rgba(255,255,255,0.10)")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            gap(12.px)
            textAlign("center")
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(10.px)
            }
        }) {
            Img(src = "images/we.svg") {
                style {
                    width(34.px)
                    height(34.px)
                    property("filter", "brightness(1.8)")
                }
            }
            H3({ style { margin(0.px); color(DashboardTheme.TEXT_LIGHT); fontSize(20.px) } }) {
                Text("Wareneingang")
            }
        }
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                gap(18.px)
                flexWrap(FlexWrap.Wrap)
            }
        }) {
            Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(18.px); fontWeight("800") } }) {
                Text("$offen offen")
            }
            Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(18.px); fontWeight("800") } }) {
                Text("$inBearbeitung in Bearbeitung")
            }
        }
    }
}

@Composable
private fun MobileWeInfoRow(label: String, value: String) {
    if (value.isBlank()) return
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(3.px)
        }
    }) {
        Span({
            style {
                color(rgba(255, 255, 255, 0.48))
                fontSize(11.px)
                fontWeight("700")
                property("letter-spacing", "0.08em")
                property("text-transform", "uppercase")
            }
        }) { Text(label) }
        Span({
            style {
                color(DashboardTheme.TEXT_LIGHT)
                fontSize(14.px)
                lineHeight("1.35")
                property("word-break", "break-word")
            }
        }) { Text(value) }
    }
}

@Composable
private fun MobileWeKpiChip(label: String, value: String) {
    Div({
        style {
            minWidth(92.px)
            padding(10.px, 12.px)
            borderRadius(14.px)
            backgroundColor(DashboardTheme.SURFACE_CARD)
            property("border", "1px solid rgba(255,255,255,0.08)")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(4.px)
        }
    }) {
        Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(11.px) } }) { Text(label) }
        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(13.px); fontWeight("700") } }) { Text(value) }
    }
}

private fun All.mobileWeSammelKey(): String {
    val stored = weSammelId.trim()
    return if (stored.isNotBlank()) "SAMMEL:$stored" else "SINGLE:${firmenId}:${lieferscheinnummer}:${id.ifBlank { lfdNr.toString() }}"
}

private fun List<All>.mobileWeSammelReps(): List<All> =
    groupBy { it.mobileWeSammelKey() }
        .values
        .map { group ->
            group.firstOrNull { it.zustand < ZustandManager.ABGESCHLOSSEN } ?: group.first()
        }

private fun List<All>.mobileWeSammelGroup(auftrag: All): List<All> {
    val key = auftrag.mobileWeSammelKey()
    return filter { it.mobileWeSammelKey() == key }
        .sortedWith(compareBy<All> { it.lieferscheinnummer }.thenBy { it.id })
}

private fun List<All>.mobileWeCompactLieferscheinnummer(fallback: All): String {
    val nummern = ifEmpty { listOf(fallback) }
        .map { it.lieferscheinnummer.trim() }
        .filter { it.isNotBlank() }
        .distinct()
        .ifEmpty { listOf(fallback.lieferscheinnummer.trim()).filter { it.isNotBlank() } }
    return if (nummern.size > 1) {
        "${nummern.size} Aufträge: ${nummern.joinToString(", ")}"
    } else {
        nummern.firstOrNull().orEmpty().ifBlank { "-" }
    }
}

private fun List<All>.mobileWeTotalPalettenLabel(fallback: All): String {
    val group = ifEmpty { listOf(fallback) }
    val total = group.sumOf { it.palettenanzahl.takeIf { value -> value > 0 } ?: 0 }
    return total.takeIf { it > 0 }?.toString() ?: "-"
}
